// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"VersionHint_rootContainer__2cpan","versionLabel":"VersionHint_versionLabel__3S3LM"};